var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20733_105133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5144 32.9152C44.9425 30.3413 41.3736 29.2509 36.7903 30.4792L20.4468 14.119L20.6628 13.3022C21.6041 9.77039 20.587 5.974 18.0093 3.39627C15.3847 0.769606 11.6534 -0.194164 8.1246 0.775172C7.62138 0.913356 7.22968 1.30877 7.09638 1.81336C6.96308 2.31795 7.10927 2.85427 7.47812 3.22332L11.4134 7.15857C12.5639 8.31189 12.5526 10.159 11.4162 11.2984C10.2888 12.4289 8.39365 12.4271 7.2707 11.3012L3.33466 7.36492C2.96562 6.99568 2.42773 6.85086 1.92314 6.98494C1.41845 7.11892 1.0245 7.5116 0.88681 8.01531C-0.0683662 11.5053 0.871282 15.2597 3.50849 17.8969C6.07939 20.4697 9.64374 21.564 14.2298 20.3331L30.5746 36.6932C29.3549 41.2752 30.407 44.8094 33.0136 47.416C35.6415 50.0459 39.3745 51.0025 42.8956 50.0364C43.3989 49.8983 43.7907 49.5028 43.9241 48.9982C44.0575 48.4936 43.9114 47.9572 43.5424 47.5881L39.608 43.6537C38.4575 42.5004 38.4687 40.6531 39.6052 39.5138C40.7467 38.3782 42.6376 38.3963 43.7507 39.5124L47.687 43.4476C48.0561 43.8167 48.5939 43.9615 49.0984 43.8274C49.603 43.6933 49.997 43.3009 50.1347 42.7972C51.0898 39.3078 50.1504 35.5524 47.5144 32.9152Z",
    fill: "#007876"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1787 26.4375L2.21467 40.4033C-0.0705811 42.6886 -0.0705811 46.4048 2.21467 48.6899C4.49993 50.9752 8.21614 50.9752 10.5013 48.6899L24.4651 34.7245L16.1787 26.4375ZM9.12512 44.1439C8.55286 44.7162 7.6261 44.7162 7.05383 44.1439C6.48167 43.5718 6.48167 42.6448 7.05383 42.0727L15.9386 33.1862C16.5108 32.6141 17.4378 32.6141 18.0099 33.1862C18.5821 33.7584 18.5821 34.6854 18.0099 35.2575L9.12512 44.1439Z",
    fill: "#007876"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.07 3.36066L47.5447 0.835366C47.0694 0.360073 46.3318 0.269253 45.7555 0.614858L37.9872 5.27531C37.1698 5.76564 37.0311 6.89328 37.7049 7.5672L38.3232 8.18537L28.4619 18.0064L32.606 22.1504L42.4673 12.3294L43.3383 13.2006C44.0122 13.8743 45.1399 13.7357 45.6302 12.9183L50.2906 5.15001C50.6361 4.57355 50.5453 3.83595 50.07 3.36066Z",
    fill: "#007876"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20733_105133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.5 0.40625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsIcon);
export default __webpack_public_path__ + "static/media/ToolsIcon.132cb945279a959069bc5ff4aeeda3c1.svg";
export { ForwardRef as ReactComponent };